import React from 'react'
import _ from 'lodash'
import { Link } from 'gatsby'
import { useTranslation } from 'react-i18next'
import { globalHistory as history } from '@reach/router'

export default ({ className, to, children, ...props }) => {
  const { i18n } = useTranslation()
  const { language, options: { whitelist } } = i18n

  const currentRoute = history.location.pathname
  const currentParts = currentRoute.split('/')
  const currentLang = _.lowerCase(currentParts[1])

  const targetParts = to.split('/')
  const targetLang = _.lowerCase(targetParts[1])

  let target

  if (~whitelist.indexOf(targetLang)) {
    target = to
  } else if(~whitelist.indexOf(currentLang) && currentLang === language) {
    const toParts = targetParts.slice()
    toParts.splice(1, 0, language)
    target = toParts.join('/')
  } else {
    target = to
  }

  return <Link className={className} to={target} {...props}>{children}</Link>
}
